module.exports = __webpack_public_path__ + "img/cancel_result.d3723a83.png";